import { GraphQLTypes, InputType, Selector } from '@zeus/index';
import { typedGql } from '@zeus/typedDocumentNode';
import { scalars } from '~/gql/utils/scalars';

const themeSelector = Selector('Theme')({
  id: true,
  name: true,
  fileName: true,
  wheelFileName: true,
  
});

export const GQL_THEMES = typedGql('query', { scalars })({
  getThemes: {
    ...themeSelector,
  },
});

export type StoredTheme = InputType<
  GraphQLTypes['Theme'],
  typeof themeSelector
>;
